// import * as moment from "moment";
// import $ from "jquery";
import _ from 'lodash';

export default {
    obter_campos (campos) { 
        let valores = {};

        if ( !campos ) {
            return valores;
        }

        campos.forEach(campo => { 
            if ( campo.type == 'label' ) {
                //
            } else if ( campo.type == 'group' || campo.type == 'tabela' ) { 
                let outros = this.obter_campos(campo.campos);
                valores = _.merge(valores, outros);
            } else if ( campo.id && campo.value ) { 
                valores[campo.id] = campo.value;
            }
        });

        return valores;
    },

    obter_obj_campos (campos, sem_valores = false) { 
        let valores = [];

        if ( !campos ) { 
            return valores;
        }

        campos.forEach(campo => { 
            if ( campo.type == 'label' ) {
                //
            } else if ( campo.type == 'group' || campo.type == 'tabela' ) { 
                let outros = this.obter_obj_campos(campo.campos, sem_valores);
                valores = _.concat(valores, outros);
            } else if ( campo.id && ( campo.value || sem_valores ) ) { 
                valores.push(campo); // [campo.id] = campo.value;
            }
        });

        return valores;
    },

    preencher_campos(modelo, valores) { 
        if ( !modelo ) { 
            return [];
        }

        if ( !valores ) { 
            return modelo;
        }

        modelo = modelo.map(campo => { 
            if ( campo.type == 'group' || campo.type == 'tabela' ) { 
                this.preencher_campos(campo.campos, valores);
            } else if ( valores[campo.id] ) { 
                campo.value = valores[campo.id];
            }

            return campo;
        });

        return modelo;
    },
}